import { getACDTypeApiText, getClientACDType } from "../model/ACDTypeUtil";
import { getACSTypeApiText, getClientACSType } from "../model/ACSTypeUtil";
import {
  ACDTYPE_TEXT_ONLY,
  ACDTYPE_IMAGE,
  ACDTYPE_VIDEO,
  ACDTYPE_AUDIO,
  ACDTYPE_IMAGE_ONLY,
  ACDTYPE_IMAGE_ARR
} from "../model/ACDTypes";

import { ACSTYPE_CONTRIBUTOR } from "../model/ACSTypes";

export function changeTextLineIDsObjectForApi(textLineIDs) {
  if (textLineIDs == null) {
    return null;
  }

  let pageIDs = Object.keys(textLineIDs);
  let toBeReturned = {};

  for (let i = 0; i < pageIDs.length; i++) {
    const pageID = pageIDs[i];
    const textLineIndexes = textLineIDs[pageID].textLineIndexes;

    toBeReturned[pageID] = {
      text_line_indices: textLineIndexes
    };
  }

  return toBeReturned;
}

export function changeTextLineIDsObjectForClient(textLineIDs) {
  if (textLineIDs == null) {
    return null;
  }

  let pageIDs = Object.keys(textLineIDs);
  let toBeReturned = {};

  for (let i = 0; i < pageIDs.length; i++) {
    const pageID = pageIDs[i];
    const textLineIndexes = textLineIDs[pageID].text_line_indices;

    toBeReturned[pageID] = {
      textLineIndexes
    };
  }

  return toBeReturned;
}

export function prepareACDItemForApi(acdItem) {
  if (acdItem == null) {
    return null;
  }

  let toBeReturned = {};

  if (acdItem.id == null) {
    throw Error("ACDItem id null");
  }

  toBeReturned.id = acdItem.id;

  const dataTypeText = getACDTypeApiText(acdItem.dataType);
  if (dataTypeText == null) {
    throw Error("ACDItem data type null");
  }

  toBeReturned.data_type = dataTypeText;

  if (acdItem.styleType == null) {
    throw Error("ACDItem style type null");
  }

  toBeReturned.style_type = getACSTypeApiText(acdItem.styleType);

  if (acdItem.text != null) {
    toBeReturned.text = acdItem.text;
  }

  toBeReturned.text_line_ids = changeTextLineIDsObjectForApi(
    acdItem.textLineIDs
  );

  if (acdItem.orderedTextLineIDs != null) {
    toBeReturned.ordered_text_line_ids = acdItem.orderedTextLineIDs.map(
      aTextLineIDs => changeTextLineIDsObjectForApi(aTextLineIDs)
    );
  }

  switch (acdItem.dataType) {
    case ACDTYPE_IMAGE:
      if (acdItem.image == null || acdItem.image.id == null) {
        throw Error("ACDItem image null");
      }

      toBeReturned.image_id = acdItem.image.id;

      break;
    case ACDTYPE_IMAGE_ONLY:
      if (acdItem.image != null && acdItem.image.id != null) {
        toBeReturned.image_id = acdItem.image.id;
      }
      break;
    case ACDTYPE_VIDEO:
      if (acdItem.media == null || acdItem.media.id == null) {
        throw Error("ACDItem video null");
      }

      toBeReturned.video_id = acdItem.media.id;
      break;
    case ACDTYPE_AUDIO:
      if (acdItem.media == null || acdItem.media.id == null) {
        throw Error("ACDItem audio null");
      }

      toBeReturned.audio_id = acdItem.media.id;
      break;
    case ACDTYPE_IMAGE_ARR:
      if (acdItem.imageItemArr == null || acdItem.imageItemArr.length <= 0) {
        throw Error("ACDItem image array null");
      }

      let nonImageArr = acdItem.imageItemArr.filter(
        anItem =>
          anItem.dataType !== ACDTYPE_IMAGE && anItem.dataType !== ACDTYPE_VIDEO
      );

      if (nonImageArr.length > 0) {
        throw Error("ACDItem image array contains non image/video items");
      }

      let modifiedImageArr = acdItem.imageItemArr.map(anItem =>
        prepareACDItemForApi(anItem)
      );

      toBeReturned.items = modifiedImageArr;

      break;
    case ACDTYPE_TEXT_ONLY:
      if (acdItem.styleType === ACSTYPE_CONTRIBUTOR) {
        if (acdItem.names == null || acdItem.names.length !== 3) {
          throw Error("ACDItem names null");
        }

        let namesDict = {};

        namesDict.text = acdItem.names[0].name;
        namesDict.illustration = acdItem.names[1].name;
        namesDict.photo = acdItem.names[2].name;

        toBeReturned.contributors = namesDict;
      }
      break;
    default:
  }

  return toBeReturned;
}

export function prepareCommonACDItemForClient(serveACDItem) {
  if (serveACDItem == null) {
    return null;
  }

  let toBeReturned = {};

  if (serveACDItem.id == null) {
    throw Error("ACDItem id null");
  }

  toBeReturned.id = serveACDItem.id;

  const dataType = getClientACDType(serveACDItem.data_type, false);

  if (dataType == null) {
    throw Error("ACDItem data type null");
  }

  toBeReturned.dataType = dataType;

  if (serveACDItem.style_type == null) {
    throw Error("ACDItem style type null");
  }

  toBeReturned.styleType = getClientACSType(serveACDItem.style_type);

  if (serveACDItem.text != null) {
    toBeReturned.text = serveACDItem.text;
  }

  toBeReturned.isTextServerProcessed = true;

  toBeReturned.textLineIDs = changeTextLineIDsObjectForClient(
    serveACDItem.text_line_ids
  );

  if (serveACDItem.ordered_text_line_ids != null) {
    toBeReturned.orderedTextLineIDs = serveACDItem.ordered_text_line_ids.map(
      aTextLineIDs => changeTextLineIDsObjectForClient(aTextLineIDs)
    );
  }

  switch (toBeReturned.dataType) {
    case ACDTYPE_IMAGE:
      if (serveACDItem.image == null || serveACDItem.image.id == null) {
        throw Error("ACDItem image null");
      }

      toBeReturned.image = serveACDItem.image;

      break;
    case ACDTYPE_VIDEO:
      if (serveACDItem.video == null || serveACDItem.video.id == null) {
        throw Error("ACDItem video null");
      }

      toBeReturned.media = serveACDItem.video;
      break;
    case ACDTYPE_AUDIO:
      if (serveACDItem.audio == null || serveACDItem.audio.id == null) {
        throw Error("ACDItem audio null");
      }

      toBeReturned.media = serveACDItem.audio;
      break;
    case ACDTYPE_IMAGE_ARR:
      if (serveACDItem.items == null || serveACDItem.items.length <= 0) {
        throw Error("ACDItem image array null");
      }

      let modifiedImageArr = serveACDItem.items.map(anItem =>
        prepareCommonACDItemForClient(anItem, false)
      );

      let nonImageArr = modifiedImageArr.filter(
        anItem =>
          anItem.dataType !== ACDTYPE_IMAGE && anItem.dataType !== ACDTYPE_VIDEO
      );

      if (nonImageArr.length > 0) {
        throw Error("ACDItem image array contains non image/video items");
      }

      toBeReturned.imageItemArr = modifiedImageArr;

      break;
    default:
  }

  return toBeReturned;
}

export function prepareMetaACDItemForClient(
  serveACDItem,
  forceID,
  dataType,
  styleType
) {
  let toBeReturned = {
    id: forceID,
    text: "",
    isTextServerProcessed: true,
    textLineIDs: null,
    dataType: dataType,
    styleType: styleType
  };

  if (styleType === ACSTYPE_CONTRIBUTOR) {
    toBeReturned.names = [
      { type: "文", name: [""] },
      { type: "圖", name: [""] },
      { type: "攝影", name: [""] }
    ];
  }

  if (serveACDItem == null) {
    return toBeReturned;
  }

  if (serveACDItem.text != null) {
    toBeReturned.text = serveACDItem.text;
  }

  toBeReturned.textLineIDs = changeTextLineIDsObjectForClient(
    serveACDItem.text_line_ids
  );

  if (serveACDItem.ordered_text_line_ids != null) {
    toBeReturned.orderedTextLineIDs = serveACDItem.ordered_text_line_ids.map(
      aTextLineIDs => changeTextLineIDsObjectForClient(aTextLineIDs)
    );
  }

  switch (toBeReturned.dataType) {
    case ACDTYPE_IMAGE_ONLY:
      if (serveACDItem.image != null && serveACDItem.image.id != null) {
        toBeReturned.image = serveACDItem.image;
      } else {
        toBeReturned.image = null;
      }
      break;
    case ACDTYPE_TEXT_ONLY:
      if (toBeReturned.styleType === ACSTYPE_CONTRIBUTOR) {
        const contributors = serveACDItem.contributors;
        if (contributors != null) {
          let textNameArr = contributors.text == null ? [] : contributors.text;
          let illustrationNameArr =
            contributors.illustration == null ? [] : contributors.illustration;
          let photoNameArr =
            contributors.photo == null ? [] : contributors.photo;

          textNameArr = textNameArr.length <= 0 ? [""] : textNameArr;
          illustrationNameArr =
            illustrationNameArr.length <= 0 ? [""] : illustrationNameArr;
          photoNameArr = photoNameArr.length <= 0 ? [""] : photoNameArr;

          toBeReturned.names = [
            { type: "文", name: textNameArr },
            { type: "圖", name: illustrationNameArr },
            { type: "攝影", name: photoNameArr }
          ];
        }
      }
      break;
    default:
  }

  return toBeReturned;
}
